import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useCreateProjectWizardSteps } from '../hooks/useCreateProjectWizardSteps';
import { selectActiveStep } from '../state/selector';
import { AnnotationAgentStep } from './steps/AnnotationAgentStep';
import { BasicsStep } from './steps/BasicsStep';
import { ConceptGroupsAndAttributesStep } from './steps/ConceptGroupsAndAttributes';
import { DatasetImport } from './steps/DatasetImport';
import { DataSplitting } from './steps/DataSplitting';
import { PeopleAllocation } from './steps/PeopleAllocation';
import { ReviewAndCreate } from './steps/ReviewAndCreate';

interface StepRendererProps {
  setRequiredFieldsFilled: (fieldsFilled: boolean) => void;
}
export const StepRenderer = ({ setRequiredFieldsFilled }: StepRendererProps) => {
  const activeStep = useAppSelector(selectActiveStep);
  const steps = useCreateProjectWizardSteps();
  switch (steps[activeStep]) {
    case 'basics':
      return <BasicsStep setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 'conceptGroupsAndAttributes':
      return <ConceptGroupsAndAttributesStep setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 'datasetImport':
      return <DatasetImport setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 'splittingAndDriftCheck':
      return <DataSplitting setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    // TODO: cleanup with cp_annotation_createproject_agent ff
    case 'annotationAgent':
      return <AnnotationAgentStep setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 'allocation':
      return <PeopleAllocation setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 'reviewAndCreate':
      return <ReviewAndCreate setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    default:
      return null;
  }
};
